import { render, staticRenderFns } from "./OpenHoursInput.vue?vue&type=template&id=1c6f7670&scoped=true"
import script from "./OpenHoursInput.vue?vue&type=script&lang=js"
export * from "./OpenHoursInput.vue?vue&type=script&lang=js"
import style0 from "./OpenHoursInput.vue?vue&type=style&index=0&id=1c6f7670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f7670",
  null
  
)

/* custom blocks */
import block0 from "./OpenHoursInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports